/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var _get = require('lodash.get');
var Backbone = require('backbone');
var NProgress = require('nprogress');

var GetAllRecordLookups = require('../../../common/services/GetAllRecordLookups');
var GetFilingDetails = require('../../../common/services/GetFilingDetails');

var CorpFinReviewFilingTaskView = require('./CorpFinReviewFilingTaskView');

module.exports = {
  event: 'build:cf:review-filing',

  channel: 'task',

  builder: function(task) {
    var defer = $.Deferred();

    var filingId = _get(task, 'taskData.CF.cfFilingId');

    $.when(GetAllRecordLookups(), GetFilingDetails(filingId))
      .done(function(recordLookups, filingDetails) {
        NProgress.set(0.85);

        defer.resolve(
          new CorpFinReviewFilingTaskView({
            model: new Backbone.Model({
              task: task,
              taskId: task.taskId,
              filingId: filingId,
              filing: filingDetails,
              filingApplicationTypes: recordLookups.filingApplicationTypes,
              filingTypes: recordLookups.filingTypes
            })
          })
        );
      })
      .fail(function(err) {
        defer.reject(err);
      });

    return defer.promise();
  }
};
